import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { medidasRouter } from "./data.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { almoxarifadoRoute } from "../../shared/data.service";

@Injectable()
export class MedidaNavigationService {
  
  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = almoxarifadoRoute + '/' + medidasRouter;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = almoxarifadoRoute + '/' + medidasRouter + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = almoxarifadoRoute + '/' + medidasRouter + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/almoxarifado/medidas/shared/medida-navigation.service.ts
 **/